'use strict';

module.exports = '3.35.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 40
// module chunks = 0